import { useEffect, useState } from "react";
import { supabase } from "../config/supabaseClient";
import { FaTrophy, FaMapMarkerAlt, FaCalendarAlt, FaPaw } from "react-icons/fa";
import { MdPets } from "react-icons/md";
import "./SucceseFindMyPet.css";

export default function SucceseFindMyPet() {
  const [succese, setSuccese] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSuccese = async () => {
      const { data, error } = await supabase
        .from("anunturi")
        .select("*")
        .eq("rezolvat", true)
        .order("rezolvat_la", { ascending: false });

      if (!error) setSuccese(data);
      setLoading(false);
    };
    fetchSuccese();
  }, []);

  return (
    <div className="succese-page">

      {/* Header */}
      <div className="succese-header">
        <FaTrophy className="succese-trophy" />
        <h1>Succese FindMyPet</h1>
        <p>
          Animale reunite cu familiile lor datorită comunității noastre.
          Fiecare poveste contează! 🐾
        </p>
        <div className="succese-counter">
          <MdPets />
          <strong>{succese.length}</strong>
        </div>
      </div>

      {loading ? (
        <p className="loading-text">Se încarcă poveștile...</p>
      ) : succese.length === 0 ? (
        <div className="no-succese">
          <FaPaw size={48} color="#ddd" />
          <p>Nu există povești de succes încă.</p>
          <small>Fii primul care ajută un animal să ajungă acasă!</small>
        </div>
      ) : (
        <div className="succese-grid">
          {succese.map((s) => (
            <div key={s.id} className="succes-card">

              {/* Imagine */}
              <div className="succes-imagine">
                {s.imagini?.[0] ? (
                  <img src={s.imagini[0]} alt="animal gasit acasa" />
                ) : (
                  <div className="succes-no-image">
                    <FaPaw size={36} color="#f97316" />
                  </div>
                )}
                <div className="succes-badge">
                   Găsit prin FindMyPet
                </div>
              </div>

              {/* Info */}
              <div className="succes-info">
                <div className="succes-titlu">
                  <strong>
                    {s.specie === "caine" ? "Caine" : "Pisica"} {s.rasa}
                  </strong>
                  <span className={`tip-badge ${s.tip}`}>
                    {s.tip === "gasit" ? "Era găsit" : "Era pierdut"}
                  </span>
                </div>

                <div className="succes-detalii">
                  <span><FaMapMarkerAlt /> {s.oras}</span>
                  <span>
                    <FaCalendarAlt />
                    {s.rezolvat_la
                      ? new Date(s.rezolvat_la).toLocaleDateString("ro-RO")
                      : "—"
                    }
                  </span>
                </div>

                {s.mesaj_succes && (
                  <div className="succes-mesaj">
                    <span className="ghilimele">"</span>
                    {s.mesaj_succes}
                    <span className="ghilimele">"</span>
                  </div>
                )}
              </div>

            </div>
          ))}
        </div>
      )}
    </div>
  );
}